export const siteSettings = {
  name: "Vortex Traders",
  link: "https://vortextraderspro.net",
  email: "support@vortextraderspro.net",
  appLink: "https://app.vortextraderspro.net",
};
